import { TimeLineDay } from './time-line-day';

export class TimeLineWeek {

    id: number;
    days: TimeLineDay[];
}